export const LOCAL_SPACE_NUMBER = 6;
export const LOCAL_DESKTOP_NUMBER = 9;
export const LOCAL_CHANNEL_NUMBER = 1;

export const SPACE_DATABASE_VERSION = 2;
export const CONTEXT_DATABASE_VERSION = 2;

//export const SPACE_DEFAULT_NAME = "Sans nom";
//export const CONTEXT_DEFAULT_NAME = "";
